<template>
	<div class="task_cont">
		<SubHeader msg="对象管理模块" />
		<div class="cornerCut">
			<div class="task_box">
				<div class="task_box_top">
					<button class="creat_task" @click="">添加对象</button>
					<div class="">
						<label>对象编号：</label>
						<input placeholder="请输入对象编号" />
						<label>对象类型：</label>
						<select>
							<option selected hidden disabled value="">请选择对象类型</option>
							<option>飞机</option>
							<option>电磁</option>
						</select>
						<button class="seach_task">查询</button>
					</div>
				</div>
				
				<el-table
					:data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
					stripe
					ref="multipleTable"
					tooltip-effect="dark"
					:header-row-class-name="header_style"
					:cell-class-nam="cell_style"
					:row-class-name="tableRowClassName"
					>
					<el-table-column prop="serial" label="序号" width="100"></el-table-column>
					<el-table-column prop="date" label="对象编号" width=""></el-table-column>
					<el-table-column prop="name" label="对象类型" width=""></el-table-column>
					<el-table-column prop="name" label="操作" width="300">
						<template slot-scope="scope">
							<el-button class="dx_btn dx_btn_edit" @click="handleClick(scope.row)">编辑</el-button>
							<el-button class="dx_btn dx_btn_del" @click="handleClick(scope.row)">删除</el-button>
							<el-button class="dx_btn dx_btn_ck" @click="handleClick(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					 layout="total,jumper,prev, pager, next"
					 @current-change="current_change"
					 :total="total"
					 background
					>
				</el-pagination>
			</div>
		</div>
		<!--创建-->
		<!-- <el-dialog class="mk1_dialog" title="新建" :visible.sync="creatVisible" :modal="false">
			<CreatTask></CreatTask>
		</el-dialog> -->
	</div>
</template>

<script>
	import SubHeader from '../components/subHeader.vue'
	// import CreatTask from '../components/creatTask.vue'
	export default {
		components: {
			SubHeader,
			// CreatTask
		},
		data() {
			return {
				creatVisible:false,
				total:5,//默认数据总数
				pagesize:7,//每页的数据条数
				currentPage:1,//默认开始页面
				tableData: [{
						serial:'1',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					}, {
						serial:'2',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'3',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'4',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'5',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'6',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'7',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'8',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'9',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'10',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'11',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},
				]
			}
		},
		mounted(){
			
		},
		created() {
			this.total=this.tableData.length;
		},
		methods:{
			handleClick(){
				
			},
			header_style({row,rowIndex}){
				return 'table-header'
			},
			cell_style({ row, column, rowIndex, columnIndex}) {
				if (columnIndex === 0 && row[column.property].indexOf('02') > -1) {
					return 'background-color: #010f23'
				} else {
					return 'text-align: center'
				}
			},
			tableRowClassName({row, rowIndex}) {
				return '';
			},
			//分页方法
			tableRowClassName({row, rowIndex}) {
				if (rowIndex === 0) {
				  return 'th';
				}
				return '';
			},
			switchChange(){
				  this.istag = !this.istag ;
				  
			},
			current_change:function(currentPage){
				this.currentPage = currentPage;
			}
		}
	}
</script>

<style>
	.dx_btn{background: transparent!important;border: 0px!important;}
	.dx_btn_edit span{color: #a276ff;}
	.dx_btn_del span{color: #ffcc00;}
	.dx_btn_ck span{color: #19e8fc;}
</style>
